namespace advisorop.components.servicer {

    export class AcctValueMonitorController {
        acctValueMonitorDetails: Array<any>;
        acctValueMonitorDetailsToShow: Array<any>;
        manualAcctValueMonitorDetails: Array<any>;
        manualAcctValueMonitorDetailsToShow: Array<any>;
        pageLen: number;
        //issuesCount: number;
        showNeto: boolean = true;
        dg: DevExpress.ui.dxDataGridOptions;
        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;
        mvDate: Date = null;
        public changeFromDate: Date;
        public changeToDate: Date;
        advisoryFirmId: number;
        public minPercentage: number = 3;
        public filterMinPercentage: boolean = true;
        public minAmount: number = 10000;
        public filterMinAmount: boolean = true;
        activeTab: number = 1;
        accountIssuesCount: number = 0;
        manualAccountIssuesCount: number = 0;

        dg2: DevExpress.ui.dxDataGridOptions;

        public minPercentage2: number = 10;
        public filterMinPercentage2: boolean = true;
        public minAmount2: number = 10000;
        public filterMinAmount2: boolean = false;

        //upToFive: number = 0;
        //fiveToTwentyFive: number = 0;
        //twentyFiveToFifty: number = 0;
        //fiftyToSeventyFive: number = 0;
        //seventyFiveToOneHundred: number = 0;

        // grid instance
        dgAcctValueMonitor: DevExpress.ui.dxDataGrid;
        dgAcctValueMonitor2: DevExpress.ui.dxDataGrid;

        isInitializing: boolean = false;
        isInitializing2: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#acctValueMonitorContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }
        loadOptions2: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#manualAcctValueMonitorContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing2"
            }
        }

        static $inject = ["advisorService", "generalService", "advisorDashboardService", "$rootScope"];
        constructor(
            private advisorService: services.AdvisorService,
            private generalService: services.GeneralService,
            private ads: services.AdvisorDashboardService,
            private $rootScope: ng.IRootScopeService
            ) {

            this.$rootScope.$on("adminModeChanged", (event: ng.IAngularEvent) => {
                this.loadAcctValueMonitor();
            });

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "HouseholdValueMonitor"
                },
                bindingOptions: {
                    dataSource: "vm.acctValueMonitorDetailsToShow",
                },
                //height: 400,
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: false
                },
                paging: {
                    pageSize: this.pageLen,
                    enabled: true
                },
                rowAlternationEnabled: true,
                //width: 1000,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: ""
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                onInitialized: function (e: any) {
                    //console.log('Initialising...');
                    this.dgAcctValueMonitor = e.component;
                },
                wordWrapEnabled: true,

                columns: [
                    { dataField: "householdName", caption: "Household", cellTemplate: "lnkHhName", width: 385 },
                    { dataField: "householdValue", caption: "Curr Value", format: "currency", width: 80 },
                    { dataField: "cashBalance", caption: "Curr Cash", format: "currency", width: 80 },
                    { dataField: "householdValueStart", caption: "Start Value", format: "currency", width: 80 },
                    { dataField: "cashBalanceStart", caption: "Start Cash", format: "currency", width: 80 },
                    { dataField: "absValueChange", caption: "Abs $ Change", format: "currency", width: 80, sortIndex: 0, sortOrder: "desc", visible: false },
                    { dataField: "valueChange", caption: "$ Change", format: "currency", width: 80 },
                    { dataField: "percentChange", caption: "% Change", format: { type: "percent", precision: 0 }, width: 80 },
                ],
                masterDetail: {
                    enabled: true,
                    template: "accounts",
                    autoExpandAll: false
                },
                onCellPrepared: this.oncp
            };

            this.dg2 = {
                export: {
                    enabled: true,
                    fileName: "ManualAccountValueMonitor"
                },
                bindingOptions: {
                    dataSource: "vm.manualAcctValueMonitorDetailsToShow",
                },
                //height: 400,
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: false
                },
                paging: {
                    pageSize: this.pageLen,
                    enabled: true
                },
                rowAlternationEnabled: true,
                //width: 1000,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: ""
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                onInitialized: function (e: any) {
                    //console.log('Initialising...');
                    this.dgAcctValueMonitor2 = e.component;
                },
                wordWrapEnabled: true,

                columns: [
                    { dataField: "householdName", caption: "Household", cellTemplate: "lnkHhName2", width: 385 },
                    { dataField: "householdValue", caption: "Curr Value", format: "currency", width: 80 },
                    { dataField: "householdValueStart", caption: "Start Value", format: "currency", width: 80 },
                    { dataField: "absValueChange", caption: "Abs $ Change", format: "currency", width: 80, sortIndex: 0, sortOrder: "desc", visible: false },
                    { dataField: "valueChange", caption: "$ Change", format: "currency", width: 80 },
                    { dataField: "percentChange", caption: "% Change", format: { type: "percent", precision: 0 }, width: 80 },
                ],
                masterDetail: {
                    enabled: true,
                    template: "manualAccounts",
                    autoExpandAll: false
                },
                onCellPrepared: this.oncp
            };
        }

        /**
         * report: AssetAllocation, Holdings, Performance, Transactions
         * level: will always be A-account or S-sleeve account
         * */
        openReport = (report: string, level: string, account: any) => {
            this.ads.calculateBackOfficeParamsAsync(level, account.accountId).then(params => {
                this.ads.openBackOfficeReport(report, params);
            });
        }

        oncp = function (e: any) {
            if (e.rowType === 'data') {
                // Withdrawals, color code excess vs shortfall
                if (e.columnIndex === 6 || e.columnIndex === 7) {
                    e.cellElement.css('color', (e.value >= 0) ? "green" : "red");
                }
            }
        }

        oncp2 = function (e: any) {
            if (e.rowType === 'data') {
                if (e.column.command === 'expand') {
                    if (!(e.row.data && e.row.data.sleeves && e.row.data.sleeves.length > 1)) {
                        e.cellElement.removeClass('dx-datagrid-expand');
                        e.cellElement.empty();
                    }
                }

                // Withdrawals, color code excess vs shortfall
                if (e.columnIndex === 8 || e.columnIndex === 9) {
                    e.cellElement.css('color', (e.value >= 0) ? "green" : "red");
                }
            }
        }

        oncp3 = function (e: any) {
            if (e.rowType === 'data') {
                // Withdrawals, color code excess vs shortfall
                if (e.columnIndex === 7 || e.columnIndex === 8) {
                    e.cellElement.css('color', (e.value >= 0) ? "green" : "red");
                }
            }
        }

        updateDxGrid(): void {
            $('#dgAcctValueMonitor').dxDataGrid("instance").refresh();
        }
        updateDxGrid2(): void {
            $('#dgAcctValueMonitor2').dxDataGrid("instance").refresh();
        }

        filterResults(): void {
            if (this.acctValueMonitorDetails && this.acctValueMonitorDetails.length > 0) {
                this.acctValueMonitorDetailsToShow = this.acctValueMonitorDetails.filter(s => ((this.filterMinPercentage === false || Math.abs(s.percentChange) >= (this.minPercentage / 100))
                    && (this.filterMinAmount === false || s.absValueChange >= this.minAmount)));
                if (this.acctValueMonitorDetailsToShow) {
                    this.accountIssuesCount = this.acctValueMonitorDetailsToShow.length;
                } else {
                    this.accountIssuesCount = 0;
                }
            }
        }
        filterResults2(): void {
            if (this.manualAcctValueMonitorDetails && this.manualAcctValueMonitorDetails.length > 0) {
                this.manualAcctValueMonitorDetailsToShow = this.manualAcctValueMonitorDetails.filter(s => ((this.filterMinPercentage2 === false || Math.abs(s.percentChange) >= (this.minPercentage2 / 100))
                    && (this.filterMinAmount2 === false || s.absValueChange2 >= this.minAmount2)));
                if (this.manualAcctValueMonitorDetailsToShow) {
                    this.manualAccountIssuesCount = this.manualAcctValueMonitorDetailsToShow.length;
                } else {
                    this.manualAccountIssuesCount = 0;
                }
            }
        }

        updateGrid(): void {
            this.filterResults();
            this.updateDxGrid();
        }
        updateGrid2(): void {
            this.filterResults2();
            this.updateDxGrid2();
        }

        loadAcctValueMonitor() {

            this.mvDate = null;

            let rez: any;

            this.isInitializing = this.activeTab == 1;
            this.isInitializing2 = this.activeTab == 2;

            //this.upToFive = 0;
            //this.fiveToTwentyFive = 0;
            //this.twentyFiveToFifty = 0;
            //this.twentyFiveToFifty = 0;
            //this.fiftyToSeventyFive = 0;
            //this.seventyFiveToOneHundred = 0;
            //this.issuesCount = 0;

            //if (this.advisoryFirmId && this.advisoryFirmId > 0) {
                //console.log("Loading account value monitor data");
            const adminMode = this.advisorService.getAdminMode();
            const adminModeEnabled = adminMode && adminMode.enabled;

            // 12/9/2020 GL - commented this next line out... not sure why it is here? No variable is being set to its results
            //this.advisorService.getMarketValueByAdvisor(adminModeEnabled, adminModeEnabled ? adminMode.advisoryFirm.id : null)

            //console.log("ADMinMode:", adminMode);
            //console.log("ADMinModeEnabled:", adminModeEnabled);

            rez = this.advisorService.getAcctValueMonitorData(adminModeEnabled, false, adminModeEnabled ? adminMode.advisoryFirm.id : null);
            //}

            rez.then(response => {
                this.acctValueMonitorDetails = response.data;
                this.filterResults();
                //console.log("AcctValueMonitorDetails:",this.acctValueMonitorDetails);
                if (this.acctValueMonitorDetailsToShow && this.acctValueMonitorDetailsToShow.length > 0) {

                    this.changeToDate = this.acctValueMonitorDetailsToShow[0].currentDateStr;
                    this.changeFromDate = this.acctValueMonitorDetailsToShow[0].startDateStr;

                    // The Market Value Date on all account rows is the same (date from the BO table), so we can take the date from the first row.
                    //this.mvDate = this.cashMonitorDetails[0].details.marketValueDate;
                    //this.upToFive = response.data.filter(w => w.cashPercentage < .05).length;
                    //this.fiveToTwentyFive = response.data.filter(w => w.cashPercentage > .05 && w.cashPercentage < .25).length;
                    //this.twentyFiveToFifty = response.data.filter(w => w.cashPercentage > .25 && w.cashPercentage < .50).length;
                    //this.fiftyToSeventyFive = response.data.filter(w => w.cashPercentage > .50 && w.cashPercentage < .75).length;
                    //this.seventyFiveToOneHundred = response.data.filter(w => w.cashPercentage > .75).length;
                    //this.issuesCount = this.cashMonitorDetails.length;
                }

                this.isInitializing = false;
            }, err => this.isInitializing = false)
            .catch(err => {
                this.generalService.showError(err);
            })
            .finally(() => {
                this.updateDxGrid();
            });

            rez = this.advisorService.getAcctValueMonitorData(adminModeEnabled, true, adminModeEnabled ? adminMode.advisoryFirm.id : null);

            rez.then(response => {
                this.manualAcctValueMonitorDetails = response.data;
                this.filterResults2();
                if (this.manualAcctValueMonitorDetailsToShow && this.manualAcctValueMonitorDetailsToShow.length > 0) {

                    this.changeToDate = this.manualAcctValueMonitorDetailsToShow[0].currentDateStr;
                    this.changeFromDate = this.manualAcctValueMonitorDetailsToShow[0].startDateStr;
                }
                this.isInitializing2 = false;
            }, err => this.isInitializing2 = false)
                .catch(err => {
                    this.generalService.showError(err);
                })
                .finally(() => {
                    this.updateDxGrid2();
                });
        };

        ///firmChanged(): void {
        //    //this.advisoryFirmId = this.selFirm.id;
        //    this.loadAcctValueMonitor();
        //}

        $onInit(): void {
            //this.servicerService.getAdvisoryFirmsLight().then(response => {
            //    this.advisoryFirms = response.data;
            //    this.selFirm = this.advisoryFirms[0];
            //    this.firmChanged();
            //}).catch(reason => {
            //});
            this.loadAcctValueMonitor();
        }

        $onChanges(evt) {
            for (var key in evt) {
                //if (key === "advisoryFirmId" && this.advisoryFirmId) {
                //    console.log("Cash Monitor details data: ");
                //    console.log(this.cashMonitorDetails);
                //}
            }
        };
    }


    class AcctValueMonitor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                //advisoryFirmId: "<",
                pageLen: "<",
                //issuesCount: "="
                changeFromDate: "=",
                changeToDate: "=",
            };
            this.controller = AcctValueMonitorController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/acct-value-monitor.html";
        }
    }
    angular.module(Constants.APP).component("acctValueMonitor", new AcctValueMonitor());

}